import { createRoot } from "react-dom/client";

// Create the root immediately - before any other module imports that might
// trigger React scheduler conflicts (e.g. styleguide ESM with bundled react-dom)
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

// Dynamically import the app bootstrap to defer all other module loading
// until after React's scheduler is fully initialized
import(/* webpackChunkName: "initApp" */ "./initApp")
  .then(({ initApp }) => {
    initApp(root);
  })
  .catch((error) => {
    const wrapper = document.createElement("div");
    wrapper.setAttribute("style", "padding:20px;color:red");
    const heading = document.createElement("h1");
    heading.textContent = "Error";
    const message = document.createElement("p");
    message.textContent = error?.message ?? "Unexpected error";
    wrapper.appendChild(heading);
    wrapper.appendChild(message);
    rootElement.replaceChildren(wrapper);
  });
